import React from 'react';
import { graphql } from 'gatsby';
import { css } from '@emotion/react';

interface AnchorProps {
    anchorId?: string
}

const styles = {
    anchor: css({
        height: 0,
    }),
};

const Anchor = (props: AnchorProps): JSX.Element => {
    const { anchorId } = props;

    return <div css={styles.anchor} id={anchorId} />;
};

export const query = graphql`
  fragment AnchorData on CsAnchor {
    ... on CsAnchor {
      anchorId
    }
  }
`;

export default Anchor;
